import { useState, useEffect } from 'react'
import { upcomingEvents } from '../services'

export const useUpcomingEvents = (sportUuid?: string) => {
  const [isLoaded, setIsLoaded] = useState(false)
  const [eventsUpcoming, setEventsUpcoming] =
    useState<Awaited<ReturnType<typeof upcomingEvents>>['data']>()

  useEffect(() => {
    if (!sportUuid) return

    upcomingEvents(sportUuid)
      .then(({ data }) => {
        setEventsUpcoming(data)
        setIsLoaded(true)
      })
      .catch(console.error)
  }, [sportUuid])

  return { isLoaded, eventsUpcoming }
}
